import React, { useEffect, useState, useMemo, useCallback } from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import RefershIcon from '../../../common/assets/images/reload.png';
import { Table, Spinner, Form } from 'react-bootstrap';
import debounce from 'lodash.debounce';
import axiosInstance from "../../../axiosinterceptor"

const AllUsers = () => {
    const navigate = useNavigate();
    const permissions = JSON.parse(sessionStorage.getItem('permissions'));
    useEffect(() => {
        if (permissions && !permissions.admin) {
            navigate('/no-access');
        }
    }, [permissions, navigate]);

    const headers = {
        authorizationToken: sessionStorage.loginSession,
    };

    const [allUsers, setAllUsers] = useState([]);
    const [refresh, setRefresh] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearch, setDebouncedSearch] = useState("");

    useEffect(() => {
        setIsLoading(true);
        axiosInstance
            .get('/getAdminUsersACS', { headers })
            .then((response) => {
                setAllUsers(response.data.data);
                setIsLoading(false);
            })
            .catch((error) => {
                console.log('Error: ' + error);
                setIsLoading(false);
            });
    }, [refresh]);

    const handleSearchChange = useCallback(
        debounce((value) => {
            setDebouncedSearch(value);
        }, 300),
        []
    );

    const onSearchInputChange = (e) => {
        setSearchTerm(e.target.value);
        handleSearchChange(e.target.value);
    };

    const filteredUsers = useMemo(
        () => allUsers.filter(user =>
            (user.username?.toLowerCase()?.includes(debouncedSearch.toLowerCase())) ||
            (user.organization_name?.toLowerCase()?.includes(debouncedSearch.toLowerCase())) ||
            (user.country_name?.toLowerCase()?.includes(debouncedSearch.toLowerCase())) ||
            (user.role?.toLowerCase()?.includes(debouncedSearch.toLowerCase())) ||
            (user.email?.toLowerCase()?.includes(debouncedSearch.toLowerCase()))
        ),
        [debouncedSearch, allUsers]
    );

    return (
        <div className="userlist-section">
            <ToastContainer autoClose={20000} />
                <p
                    className="userlist-back-btn"
                    onClick={() => navigate("/admin")}
                >
                  « Back
                </p>
            <div className="userlist-header">
            
                <h4 className="userlist-header-text">Approved Users</h4>
                <div className="userlist-filter-section">
                    <Form.Control 
                        type="text" 
                        placeholder="Search..." 
                        value={searchTerm} 
                        onChange={onSearchInputChange} 
                        style={{ marginRight: '10px' }}
                    />
                    <span className="userlist-refresh-btn" onClick={() => setRefresh(!refresh)}>
                        <span>
                            <img src={RefershIcon} alt="img" />
                        </span>
                    </span>
                </div>
            </div>
            <div className="userlist-table-container">
                <Table responsive="sm" style={{ textAlign: 'center' }} className="userlist-filter-table">
                    <thead className="userlist-thead">
                        <tr className="userlist-tr">
                            <th className="userlist-th">Username</th>
                            <th className="userlist-th">Organization</th>
                            <th className="userlist-th">Country</th>
                            <th className="userlist-th">Role</th>
                            <th className="userlist-th">Email</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr>
                                <td colSpan="6">
                                    <div className="userlist-table-loader">
                                        <Spinner />
                                    </div>
                                </td>
                            </tr>
                        ) :  filteredUsers && filteredUsers .length > 0 ? (
                            filteredUsers.map((user, index) => (
                                <tr key={index}>
                                    <td className="userlist-td">{user.username}</td>
                                    <td className="userlist-td">{user.organization_name}</td>
                                    <td className="userlist-td">{user.country_name}</td>
                                    <td className="userlist-td">{user.role}</td>
                                    <td className="userlist-td">{user.email}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6">
                                    <p className="mb-0">No Records Found</p>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default AllUsers;
